(function () {
  function swipe(el, onLeft, onRight) {
    var x = null;
    el.addEventListener('touchstart', function (e) { x = e.touches && e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x === null || !e.changedTouches || !e.changedTouches[0]) return;
      var d = e.changedTouches[0].clientX - x; x = null;
      if (d < -40) onLeft(); else if (d > 40) onRight();
    });
  }
  document.querySelectorAll('[data-kp-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-kp-track]');
    if (!track) return;
    var n = track.children.length, i = 0;
    var dots = root.querySelectorAll('[data-kp-dot]');
    var counter = root.querySelector('[data-kp-counter]');
    function go(k) {
      i = ((k % n) + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
    }
    var p = root.querySelector('[data-kp-prev]'), q = root.querySelector('[data-kp-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (q) q.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    swipe(root.querySelector('[data-kp-swipe]') || root, function () { go(i + 1); }, function () { go(i - 1); });
  });
  document.querySelectorAll('[data-kp-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-kp-main]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-kp-thumb]'));
    var n = thumbs.length, i = 0;
    if (!main || n < 2) return;
    function go(k) {
      i = ((k % n) + n) % n;
      var t = thumbs[i];
      main.src = t.getAttribute('data-src');
      main.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
    }
    thumbs.forEach(function (b, j) { b.addEventListener('click', function () { go(j); }); });
    var p = g.querySelector('[data-kp-prev]'), q = g.querySelector('[data-kp-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (q) q.addEventListener('click', function () { go(i + 1); });
    swipe(g.querySelector('[data-kp-stage]') || g, function () { go(i + 1); }, function () { go(i - 1); });
  });
  document.querySelectorAll('[data-kp-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('[data-kp-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = Math.min(9, Math.max(1, v + parseInt(b.getAttribute('data-kp-qty'), 10)));
      input.value = v;
    });
  });
})();
